import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../utils/constants";

export const getCategories = createAsyncThunk(
  'categories/getCategories',
  async (_,thunkAPI) => {
    try {
      const res = await axios(`${BASE_URL}/categories`);
        return res.data;
    } catch(err) {
      console.log(err)
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message || 'Помилка при завантаженні категорій');
    }
  }
);

export const createCategory = createAsyncThunk(
  'categories/createCategory',
  async (formData, thunkAPI) => {
    try {
      const res = await axios.post(`${BASE_URL}/categories`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return res.data;
    } catch(err) {
      console.log(err)
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message || 'Помилка при завантаженні категорій');
    }
  }
);

export const updateCategory = createAsyncThunk(
  'categories/updateCategory',
  async ({ id, formData }, thunkAPI) => {
    try {
      const res = await axios.post(`${BASE_URL}/categories/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return res.data;
    } catch(err) {
      console.log(err)
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message || 'Помилка при завантаженні категорій');
    }
  }
);

export const deleteCategory = createAsyncThunk(
  'categories/deleteCategory',
  async (id, thunkAPI) => {
    try {
      await axios.delete(`${BASE_URL}/categories/${id}`);
      return id;
    } catch(err) {
      console.log(err)
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message || 'Помилка при завантаженні категорій');
    }
  }
);


const categoriesSlice = createSlice({
  name: 'categories',
  initialState:{
    list: [],
    isLoading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(getCategories.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCategories.fulfilled, (state, { payload }) => {
      state.list = payload;
      state.isLoading = false;
    });
    builder.addCase(getCategories.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(createCategory.fulfilled, () => {
      // Список обновляется через getCategories() после создания
    });
    builder.addCase(updateCategory.fulfilled, (state, { payload }) => {
      const index = state.list.findIndex(item => item.id === payload.id);
      if (index !== -1) {
        state.list[index] = payload;
      }
    });
    builder.addCase(deleteCategory.fulfilled, (state, { payload }) => {
      state.list = state.list.filter(item => item.id !== payload);
    });
  },
});

export default categoriesSlice.reducer;